<template>
  <iframe
    :id="id"
    :src="iframeSrc"
    frameborder="0"
    :height="height"
    scrolling="auto"
    style="background-color: #fff;"
    width="100%"
  ></iframe>
</template>

<script>
import PageLayout from '../page/PageLayout'
import RouteView from './RouteView'

export default {
  name: 'IframePageContent',

  data() {
    return {
      url: '',
      id: ''
    }
  },
  props: {
    iframeSrc: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '800px'
    }
  },
  created() {
    // this.goUrl()
  },
  updated() {
    // this.goUrl()
  },
  watch: {
    $route(to, from) {
      // this.goUrl();
    }
  },
  methods: {
    goUrl() {
      let url = this.$route.meta.url
      let id = this.$route.path
      // this.id = id
      //url = "http://www.baidu.com"
      console.log('------url------' + url)
      if (url !== null && url !== undefined) {
        this.url = url
        //window.open(this.url);
      }
    }
  }
}
</script>

<style>

</style>
